import React, { useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import { general, http, useNavigationService } from "../fx-core";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import "./TrendingVideos.scss";
import { getCookies } from "./api";
import logo from "../../assets/logo.png";

const IconGear = ({ size = 22, color = "#fff" }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M12 15.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z" stroke={color} strokeWidth="1.8"/>
    <path d="M19.4 13.5a7.6 7.6 0 000-3l2.1-1.6-2-3.5-2.5 1a7.6 7.6 0 00-2.6-1.5l-.4-2.7H10l-.4 2.7a7.6 7.6 0 00-2.6 1.5l-2.5-1-2 3.5 2.1 1.6a7.6 7.6 0 000 3l-2.1 1.6 2 3.5 2.5-1a7.6 7.6 0 002.6 1.5l.4 2.7h3.2l.4-2.7a7.6 7.6 0 002.6-1.5l2.5 1 2-3.5-2.1-1.6z" stroke={color} strokeWidth="1.2"/>
  </svg>
);
const IconHeart = ({ size = 26, color = "#fff", filled = false }: { size?: number; color?: string; filled?: boolean }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={filled ? color : "none"} stroke={color} strokeWidth="1.8">
    <path d="M12 21s-7.5-4.6-9.5-8.6A5.5 5.5 0 018.6 6c1.5 0 2.8.7 3.4 1.8C12.6 6.7 14 6 15.4 6a5.5 5.5 0 016.1 6.4C19.5 16.4 12 21 12 21z"/>
  </svg>
);
const IconEye = ({ size = 16, color = "#fff" }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M1.5 12s4-7.5 10.5-7.5S22.5 12 22.5 12s-4 7.5-10.5 7.5S1.5 12 1.5 12z" stroke={color} strokeWidth="1.8"/>
    <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="1.8"/>
  </svg>
);
const IconShare = ({ size = 22, color = "#fff" }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="18" cy="5" r="3" stroke={color} strokeWidth="1.8"/>
    <circle cx="6" cy="12" r="3" stroke={color} strokeWidth="1.8"/>
    <circle cx="18" cy="19" r="3" stroke={color} strokeWidth="1.8"/>
    <path d="M8.7 11l6.6-3.2M8.7 13l6.6 3.2" stroke={color} strokeWidth="1.8"/>
  </svg>
);
const IconPlay = ({ size = 64, color = "#fff" }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
    <polygon points="24,18 24,46 46,32" fill={color}/>
  </svg>
);
const IconSpeakerOn = ({ size = 24, color = "#fff" }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M3 10h4l5-4v12l-5-4H3z" fill={color}/>
    <path d="M16 8c1.7 1.7 1.7 6.3 0 8" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M19 5c3 3 3 11 0 14" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);
const IconSpeakerOff = ({ size = 24, color = "#fff" }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M3 10h4l5-4v12l-5-4H3z" fill={color}/>
    <path d="M18 6l-6 6m0 0l6 6" stroke={color} strokeWidth="2" />
  </svg>
);
const IconArrowUp = ({ size = 32, color = "#fff" }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <polyline points="6 15 12 9 18 15" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const IconArrowDown = ({ size = 32, color = "#fff" }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <polyline points="6 9 12 15 18 9" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const IconClose = ({ size = 24, color = "#fff" }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <line x1="18" y1="6" x2="6" y2="18" stroke={color} strokeWidth="2"/>
    <line x1="6" y1="6" x2="18" y2="18" stroke={color} strokeWidth="2"/>
  </svg>
);

type VideoItem = {
  id: string;
  title: string;
  description: string;
  videoUrl: string;
  thumbUrl: string;
  userId: number;
  hlsKey: string;
  likes: number;
  views: number;
  stallId: number;
  uploadedDate: string;
};

// ✅ UPDATED: Changed from "auto" | "1080p" | "480p" to only "1080p" | "480p"
type QualityChoice = "1080p" | "480p";

const TrendingVideos = (props: any) => {
  const userId = Number(localStorage.getItem("userId")) || 1;
  const { code, videoId } = useParams<{ code: string, videoId: string }>();
  
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
    isMobile: window.innerWidth <= 599,
    isTablet: window.innerWidth >= 600 && window.innerWidth <= 1023,
    isDesktop: window.innerWidth >= 1024 && window.innerWidth <= 1439,
    isLargeDesktop: window.innerWidth >= 1440
  });
  
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      setScreenSize({
        width,
        height,
        isMobile: width <= 599,
        isTablet: width >= 600 && width <= 1023,
        isDesktop: width >= 1024 && width <= 1439,
        isLargeDesktop: width >= 1440
      });
    };
    window.addEventListener("resize", handleResize);
    
    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const history = useHistory();
  const [videoList, setVideoList] = useState<VideoItem[]>([]);
  const [likes, setLikes] = useState<number[]>([]);
  const [liked, setLiked] = useState<boolean[]>([]);
  const [views, setViews] = useState<number[]>([]);
  const [index, setIndex] = useState(0);

  const [currentOffset, setCurrentOffset] = useState<number | null>(0);
  const [seed, setSeed] = useState(() => Math.floor(Math.random() * 1000000));
  const [baseVideoSnapshot, setBaseVideoSnapshot] = useState<string | null>(null);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  
  
  // ✅ UPDATED: Default quality changed from "auto" to "1080p"
  const [quality, setQuality] = useState<QualityChoice>("1080p");
  
  const [showMenu, setShowMenu] = useState(false);
  const [isNativeHls, setIsNativeHls] = useState(false);
  const [currentHeight, setCurrentHeight] = useState<number | null>(null);
  const [isPaused, setIsPaused] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showBigHeart, setShowBigHeart] = useState(false);
  const [stallInfo, setStallInfo] = useState<any>(null);
  const [showDescriptionDrawer, setShowDescriptionDrawer] = useState(false);
  
  const community = useSelector<any, any>(s => s.community);
  const { navigate, navigateRoot } = useNavigationService();
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const cardRef = useRef<HTMLDivElement | null>(null);
  const hlsRef = useRef<Hls | null>(null);
  const animatingRef = useRef(false);
  const viewedOnceRef = useRef<Set<number>>(new Set());
  const progressWrapRef = useRef<HTMLDivElement | null>(null);
  const [isMuted, setIsMuted] = useState(true);

  const startYRef = useRef<number | null>(null);
  const startXRef = useRef<number | null>(null);
  const draggingRef = useRef(false);
  const lastDyRef = useRef(0);
  const startTimeRef = useRef<number>(0);
  const lastTapRef = useRef<number>(0);
  const singleTapTimerRef = useRef<number | null>(null);

  const SWIPE_TRIGGER_PX = 80;
  const TAP_MOVE_TOLERANCE = 10;
  const DOUBLE_TAP_MS = 300;
  const MAX_DRAG_PX = 160;

  const [size, setSize] = useState({ width: 360, height: 640 });
  useEffect(() => {
    const { width: vw, height: vh, isMobile, isTablet, isDesktop, isLargeDesktop } = screenSize;
    
    if (isMobile) {
      setSize({ width: vw, height: vh - 52 });
    } else if (isTablet) {
      const maxWidth = Math.min(480, vw - 40);
      const maxHeight = Math.min(vh - 80, 854);
      const aspectRatio = 9/16;
      let cardWidth = maxWidth;
      let cardHeight = cardWidth / aspectRatio;
      if (cardHeight > maxHeight) {
        cardHeight = maxHeight;
        cardWidth = cardHeight * aspectRatio;
      }
      setSize({ width: cardWidth, height: cardHeight });
    } else if (isDesktop) {
      const maxWidth = Math.min(600, vw - 80);
      const maxHeight = Math.min(vh - 100, 900);
      const aspectRatio = 9/16;
      let cardWidth = maxWidth;
      let cardHeight = cardWidth / aspectRatio;
      if (cardHeight > maxHeight) {
        cardHeight = maxHeight;
        cardWidth = cardHeight * aspectRatio;
      }
      setSize({ width: cardWidth, height: cardHeight });
    } else {
      const maxWidth = Math.min(720, vw - 120);
      const maxHeight = Math.min(vh - 120, 1080);
      const aspectRatio = 9/16;
      let cardWidth = maxWidth;
      let cardHeight = cardWidth / aspectRatio;
      if (cardHeight > maxHeight) {
        cardHeight = maxHeight;
        cardWidth = cardHeight * aspectRatio;
      }
      setSize({ width: cardWidth, height: cardHeight });
    }
  }, [screenSize]);

  useEffect(() => { getCookies("/outputs/hls/*", 24).catch(() => {}); }, []);
  
  // useEffect(() => {
  //   http.get({ url: "/videos/feed", params: { limit: 10, offset: 0 } })
  //     .then(res => { if (Array.isArray(res.data?.items)) setVideoList(res.data.items); })
  //     .catch(() => setVideoList([]));
  // }, []);

  useEffect(() => {
  // ⭐ Initial fetch with seed
  http.get({ 
    url: "/videos/feed", 
    params: { 
      limit: 10, 
      offset: 0,
      seed: seed 
    } 
  })
    .then(res => {
      if (Array.isArray(res.data?.items)) {
        setVideoList(res.data.items);
        setCurrentOffset(res.data.nextOffset || 10);
        
        // ⭐ Store base snapshot from first response
        if (res.data.baseVideoSnapshot) {
          setBaseVideoSnapshot(res.data.baseVideoSnapshot);
        }
        
        // ⭐ Optional: Log new videos count
        if (res.data.newVideosCount > 0) {
          console.log(`${res.data.newVideosCount} new videos available!`);
        }
      }
    })
    .catch(() => setVideoList([]));
}, []); // Only run once on mount

  
 useEffect(() => {
  if (videoList.length === 0) return;
  
  // ⭐ Check if this is initial load (first 10 videos) or adding more
  const isInitialLoad = likes.length === 0 || videoList.length === 10;
  
  if (isInitialLoad) {
    // Initial load: Reset everything
    console.log('🎬 Initial load: Setting up state');
    setLikes(videoList.map(item => item.likes ?? 0));
    setLiked(videoList.map(() => false));
    setViews(videoList.map(item => item.views ?? 0));
    setIndex(0);
    viewedOnceRef.current = new Set();
  } else {
    // Adding more videos: Only extend arrays, DON'T reset index
    console.log(`➕ Extending arrays from ${likes.length} to ${videoList.length}`);
    const newVideos = videoList.slice(likes.length);
    setLikes(prev => [...prev, ...newVideos.map(item => item.likes ?? 0)]);
    setLiked(prev => [...prev, ...new Array(newVideos.length).fill(false)]);
    setViews(prev => [...prev, ...newVideos.map(item => item.views ?? 0)]);
    // ⭐ NO setIndex(0) here!
  }
}, [videoList]);


  useEffect(() => {
  console.log(`📊 VideoList updated: ${videoList.length} videos, current index: ${index}`);
}, [videoList.length, index]);
  
  useEffect(() => {
    if (videoList.length && code && !videoId) {
      history.replace(`/${code}/trendingpage/${videoList[0].id}`);
    }
  }, [videoList, code, videoId, history]);

  const src = videoList[index]?.videoUrl || "";
  
 useEffect(() => {
  if (!videoList.length || !videoId) return;
  const idx = videoList.findIndex(v => v.id === videoId);
  
  // ⭐ Only update index if we're behind or it's a new session
  if (idx !== -1 && idx > index) {
    console.log(`🔄 URL sync: Advancing index from ${index} to ${idx}`);
    setIndex(idx);
  } else if (idx !== -1 && index === 0) {
    // Allow initial load
    console.log(`🔄 URL sync: Initial load to index ${idx}`);
    setIndex(idx);
  }
}, [videoList, videoId]);

  
  useEffect(() => {
    if (!videoList.length) return;
    const currentVideo = videoList[index];
    if (!currentVideo) return;
    if (currentVideo.id !== videoId) {
      history.replace(`/${code}/trendingpage/${currentVideo.id}`);
    }
  }, [index, videoList, history, videoId, code]);
  
  useEffect(() => {
    const stallId = videoList[index]?.stallId;
    if (!stallId) { setStallInfo(null); return; }
    http.get({ url: `/portal/stall/${stallId}` })
      .then(res => setStallInfo(res.data))
      .catch(() => setStallInfo(null));
  }, [index, videoList]);

  const findLevelIndexByHeight = (hls: Hls, targetHeight: number) => {
    const levels = hls.levels || [];
    for (let i = 0; i < levels.length; i++) if (levels[i]?.height === targetHeight) return i;
    let bestBelowIdx = -1, bestBelowH = -1;
    for (let i = 0; i < levels.length; i++) {
      const h = levels[i]?.height || 0;
      if (h > bestBelowH && h <= targetHeight) { bestBelowH = h; bestBelowIdx = i; }
    }
    if (bestBelowIdx !== -1) return bestBelowIdx;
    let bestAboveIdx = -1, bestAboveH = Number.MAX_SAFE_INTEGER;
    for (let i = 0; i < levels.length; i++) {
      const h = levels[i]?.height || 0;
      if (h > targetHeight && h < bestAboveH) { bestAboveH = h; bestAboveIdx = i; }
    }
    return bestAboveIdx;
  };

  // ✅ UPDATED: Removed "auto" logic
  const applyQuality = (hls: Hls | null, choice: QualityChoice) => {
    if (!hls) return;
    const target = choice === "1080p" ? 1080 : 480;
    const idx = findLevelIndexByHeight(hls, target);
    if (idx >= 0) {
      hls.currentLevel = idx;
      setCurrentHeight(hls.levels[idx]?.height || target);
    } else {
      hls.currentLevel = -1;
    }
  };

  const destroyHls = () => { if (hlsRef.current) { hlsRef.current.destroy(); hlsRef.current = null; } };

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    setShowMenu(false);
    setIsNativeHls(false);
    setCurrentHeight(null);
    setIsPaused(false);
    setProgress(0);
    destroyHls();
    video.removeAttribute("src");
    video.load();
    video.muted = true;
    video.loop = true;

    const onEnded = () => {
      try { video.currentTime = 0; void video.play(); }
      catch { setIsPaused(true); }
    };
    const onPlay = () => setIsPaused(false);
    const onPause = () => setIsPaused(true);
    const onTimeUpdate = () => {
      if (!video.paused && video.currentTime >= 2 && !viewedOnceRef.current.has(index)) {
        viewedOnceRef.current.add(index);
        const currentVideo = videoList[index];
        if (currentVideo) {
          http.put({ url: `/videos/${currentVideo.id}/view` }).then(res => {
            setViews(prev => {
              const arr = prev.slice(); arr[index] = res.data?.views ?? (arr[index] + 1); return arr;
            });
          }).catch(() => {
            setViews(prev => {
              const arr = prev.slice(); arr[index] = arr[index] + 1; return arr;
            });
          });
        }
      }
      const dur = Number.isFinite(video.duration) ? video.duration : 0;
      if (dur > 0) setProgress(video.currentTime / dur);
    };
    const onLoadedMetadata = () => setProgress(0);

    video.addEventListener("ended", onEnded);
    video.addEventListener("play", onPlay);
    video.addEventListener("pause", onPause);
    video.addEventListener("timeupdate", onTimeUpdate);
    video.addEventListener("loadedmetadata", onLoadedMetadata);
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
// Now check for both canPlayType AND browser is Safari
if (
  video.canPlayType("application/vnd.apple.mpegurl")
  && isSafari
) {
  setIsNativeHls(true);
  video.src = src;
  video.play().catch(() => setIsPaused(true));
} else if (Hls.isSupported()) {
      const hls = new Hls({
        enableWorker: true,
        lowLatencyMode: false,
        capLevelToPlayerSize: true,
        startLevel: -1,
        xhrSetup: (xhr: XMLHttpRequest) => { xhr.withCredentials = true; },
      });
      hlsRef.current = hls;
      hls.attachMedia(video);
      hls.on(Hls.Events.MEDIA_ATTACHED, () => hls.loadSource(src));
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        applyQuality(hls, quality);
        video.play().catch(() => setIsPaused(true));
      });
      hls.on(Hls.Events.LEVEL_SWITCHED, (_e, data) => setCurrentHeight(hls.levels?.[data.level]?.height || null));
      hls.on(Hls.Events.ERROR, (_evt, data) => {
        if (data.fatal) {
          switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR: hls.startLoad(); break;
            case Hls.ErrorTypes.MEDIA_ERROR: hls.recoverMediaError(); break;
            default: destroyHls();
          }
        }
      });
    }

    return () => {
      video.removeEventListener("ended", onEnded);
      video.removeEventListener("play", onPlay);
      video.removeEventListener("pause", onPause);
      video.removeEventListener("timeupdate", onTimeUpdate);
      video.removeEventListener("loadedmetadata", onLoadedMetadata);
    };
  }, [index, src, quality, videoList]);

  useEffect(() => { if (hlsRef.current) applyQuality(hlsRef.current, quality); }, [quality]);


const loadMoreVideos = (forceSeed?: number, forceOffset?: number) => {
  if (isLoadingMore) return;
  
  // ⭐ Use forced values if provided, otherwise use state
  const useOffset = forceOffset !== undefined ? forceOffset : currentOffset;
  const useSeed = forceSeed !== undefined ? forceSeed : seed;
  
  if (useOffset === null) {
    console.log('⚠️ Already at end, skipping load');
    return;
  }
  
  setIsLoadingMore(true);
  
  console.log('📤 Loading more with params:', {
    offset: useOffset,  // ⭐ Use parameter!
    seed: useSeed,      // ⭐ Use parameter!
    baseSnapshot: baseVideoSnapshot ? baseVideoSnapshot.split(',').length + ' videos' : 'null',
    currentVideoCount: videoList.length
  });
  
  http.get({
    url: "/videos/feed",
    params: {
      limit: 10,
      offset: useOffset,  // ⭐ Use parameter!
      seed: useSeed,      // ⭐ Use parameter!
      baseVideoSnapshot: baseVideoSnapshot
    }
  })
    .then(res => {
      console.log('📥 Response:', {
        itemsCount: res.data?.items?.length,
        recycled: res.data?.recycled,
        nextOffset: res.data?.nextOffset,
        totalVideos: res.data?.totalVideos
      });
      
      const newItems = res.data?.items || [];
      
      // CHECK: Backend correctly signaled recycling
      if (res.data?.recycled === true) {
        console.log('🔄 RECYCLING: Backend signaled end');
        
        const newSeed = Math.floor(Math.random() * 1000000);
        setSeed(newSeed);
        setCurrentOffset(0);
        
        console.log('✅ Ready for next cycle with seed:', newSeed);
        return;
      }
      
      // CHECK: Reached end but backend didn't signal it
      if (res.data?.nextOffset === null && useOffset > 0) {
        console.log('⚠️ BACKEND BUG: Should be recycled=true but got recycled=false');
        
        if (newItems.length > 0) {
          const existingIds = new Set(videoList.map(v => v.id));
          const uniqueNewItems = newItems.filter((item: any) => !existingIds.has(item.id));
          
          if (uniqueNewItems.length > 0) {
            console.log(`✅ Adding ${uniqueNewItems.length} unique videos`);
            setVideoList(prev => [...prev, ...uniqueNewItems]);
          } else {
            console.log('⚠️ All returned videos are duplicates, skipping');
          }
        }
        
        // ⭐ Generate new seed and prepare for recycle
        const newSeed = Math.floor(Math.random() * 1000000);
        setSeed(newSeed);
        setCurrentOffset(0);
        console.log('🔁 Prepared for next cycle with seed:', newSeed);
        
        // ⭐ Call loadMore with BOTH new seed AND offset=0!
        setIsLoadingMore(false);
        setTimeout(() => {
          console.log('🚀 Auto-fetching with new seed:', newSeed, 'and offset: 0');
          loadMoreVideos(newSeed, 0);  // ⭐ PASS BOTH PARAMETERS!
        }, 50);
        return;
      }
      
      // CHECK: This is a RECYCLED request (offset=0 after reset)
      if (useOffset === 0 && videoList.length > 0) {
        console.log('🔄 RECYCLING: Adding reshuffled videos for infinite scroll');
        
        if (newItems.length > 0) {
          setVideoList(prev => [...prev, ...newItems]);
          setCurrentOffset(res.data?.nextOffset || 10);
          console.log(`✅ Added ${newItems.length} reshuffled videos, next offset: ${res.data?.nextOffset || 10}`);
        } else {
          console.log('⚠️ Empty response during recycle');
          setCurrentOffset(null);
        }
        return;
      }
      
      // NORMAL PAGINATION
      if (newItems.length > 0) {
        const existingIds = new Set(videoList.map(v => v.id));
        const uniqueNewItems = newItems.filter((item: any) => !existingIds.has(item.id));
        
        if (uniqueNewItems.length > 0) {
          setVideoList(prev => [...prev, ...uniqueNewItems]);
          setCurrentOffset(res.data?.nextOffset || (useOffset + 10));
          console.log(`✅ Added ${uniqueNewItems.length} videos, next offset: ${res.data?.nextOffset}`);
        } else {
          console.log('⚠️ All videos are duplicates');
          setCurrentOffset(null);
        }
      } else {
        console.log('⚠️ Empty response');
        setCurrentOffset(null);
      }
    })
    .catch(err => {
      console.error('❌ Failed to load:', err);
      setCurrentOffset(null);
    })
    .finally(() => setIsLoadingMore(false));
};




  // const stepNext = () => setIndex((p) => (videoList.length ? (p + 1) % videoList.length : 0));

const stepNext = () => {
  const nextIdx = index + 1;
  
  console.log(`🎬 Step Next: current=${index}, next=${nextIdx}, total=${videoList.length}`);
  
  // Check if we're getting close to end (trigger loadMore)
  const videosRemaining = videoList.length - nextIdx - 1;
  if (videosRemaining <= 2 && !isLoadingMore && currentOffset !== null) {
    console.log('📍 Close to end, triggering load more');
    loadMoreVideos();
  }
  
  // ⭐ If at end, loop back to start
  if (nextIdx >= videoList.length) {
    if (videoList.length === 0) {
      console.log('⚠️ No videos');
      return;
    }
    
    console.log('🔄 Reached end, looping back to start');
    setIndex(0);
    return;
  }
  
  // Advance to next video
  console.log(`✅ Advancing to video ${nextIdx + 1}/${videoList.length}`);
  setIndex(nextIdx);
};





 const stepPrev = () => {
  if (index <= 0) {
    setIndex(videoList.length - 1); // Go to last video
  } else {
    setIndex(index - 1);
  }
};
  const applyDragVisual = (dy: number) => {
    const el = cardRef.current;
    if (!el) return;
    const clamped = Math.max(-MAX_DRAG_PX, Math.min(MAX_DRAG_PX, dy));
    el.style.transition = "none";
    el.style.transform = `translateY(${clamped}px)`;
    el.style.opacity = String(Math.max(0.75, 1 - Math.abs(clamped) / 300));
  };

  const resetToRest = () => {
    const el = cardRef.current;
    if (!el) return;
    el.style.transition = "transform 220ms ease, opacity 220ms ease";
    el.style.transform = "translateY(0)";
    el.style.opacity = "1";
  };

  const commitSwipe = (dir: "next" | "prev") => {
    const el = cardRef.current;
    if (!el || animatingRef.current) return;
    animatingRef.current = true;
    const outTo = dir === "next" ? 260 : -260;
    el.style.transition = "transform 220ms ease, opacity 220ms ease";
    el.style.transform = `translateY(${outTo}px)`;
    el.style.opacity = "0";
    window.setTimeout(() => {
      if (dir === "next") stepNext(); else stepPrev();
      el.style.transition = "none";
      el.style.transform = `translateY(${dir === "next" ? -260 : 260}px)`;
      el.style.opacity = "0";
      void el.offsetHeight;
      el.style.transition = "transform 240ms ease, opacity 240ms ease";
      el.style.transform = "translateY(0)";
      el.style.opacity = "1";
      window.setTimeout(() => { animatingRef.current = false; }, 260);
    }, 220);
  };

  const isNoDragTarget = (t: EventTarget | null) =>
    !!(t && (t as HTMLElement).closest("[data-nodrag]"));

  const togglePlayPause = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) v.play().catch(() => {});
    else v.pause();
  };

  const likeCurrent = () => {
    handleLike();
    setShowBigHeart(true);
    setTimeout(() => setShowBigHeart(false), 500);
  };

  const onPointerDown = (e: React.PointerEvent<HTMLDivElement>) => {
    if (isNoDragTarget(e.target)) return;
    draggingRef.current = true;
    startYRef.current = e.clientY;
    startXRef.current = e.clientX;
    lastDyRef.current = 0;
    startTimeRef.current = performance.now();
    (e.currentTarget as HTMLDivElement).setPointerCapture(e.pointerId);
  };

  const onPointerMove = (e: React.PointerEvent<HTMLDivElement>) => {
    if (!draggingRef.current || startYRef.current === null) return;
    const dy = e.clientY - startYRef.current;
    const dx = Math.abs(e.clientX - (startXRef.current || 0));
    
    if (dx < Math.abs(dy)) {
      lastDyRef.current = dy;
      applyDragVisual(dy);
    }
  };

  const onPointerUp = (e: React.PointerEvent<HTMLDivElement>) => {
    if (draggingRef.current) {
      draggingRef.current = false;
      (e.currentTarget as HTMLDivElement).releasePointerCapture(e.pointerId);
      const dy = lastDyRef.current;
      const dt = performance.now() - startTimeRef.current;
      lastDyRef.current = 0;

      if (Math.abs(dy) >= SWIPE_TRIGGER_PX) {
        commitSwipe(dy > 0 ? "prev" : "next");
        return;
      }

      if (Math.abs(dy) <= TAP_MOVE_TOLERANCE && dt < 350) {
        const now = performance.now();
        if (now - lastTapRef.current < DOUBLE_TAP_MS) {
          if (singleTapTimerRef.current) {
            window.clearTimeout(singleTapTimerRef.current);
            singleTapTimerRef.current = null;
          }
          lastTapRef.current = 0;
          likeCurrent();
        } else {
          lastTapRef.current = now;
          singleTapTimerRef.current = window.setTimeout(() => {
            togglePlayPause();
            singleTapTimerRef.current = null;
          }, DOUBLE_TAP_MS);
        }
      } else {
        resetToRest();
      }
    }
  };

  const onPointerCancel = () => {
    draggingRef.current = false;
    lastDyRef.current = 0;
    resetToRest();
  };

  const onTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    if (isNoDragTarget(e.target)) return;
    startYRef.current = e.touches[0].clientY;
    startXRef.current = e.touches[0].clientX;
    lastDyRef.current = 0;
    startTimeRef.current = performance.now();
    draggingRef.current = true;
  };

  const onTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    if (!draggingRef.current || startYRef.current === null) return;
    const dy = e.touches[0].clientY - startYRef.current;
    const dx = Math.abs(e.touches[0].clientX - (startXRef.current || 0));
    
    if (dx < Math.abs(dy)) {
      lastDyRef.current = dy;
      applyDragVisual(dy);
    }
  };

  const onTouchEnd = () => {
    if (!draggingRef.current) return;
    const dy = lastDyRef.current;
    const dt = performance.now() - startTimeRef.current;
    draggingRef.current = false;
    lastDyRef.current = 0;

    if (Math.abs(dy) >= SWIPE_TRIGGER_PX) {
      commitSwipe(dy > 0 ? "prev" : "next");
      return;
    }

    if (Math.abs(dy) <= TAP_MOVE_TOLERANCE && dt < 350) {
      const now = performance.now();
      if (now - lastTapRef.current < DOUBLE_TAP_MS) {
        if (singleTapTimerRef.current) {
          window.clearTimeout(singleTapTimerRef.current);
          singleTapTimerRef.current = null;
        }
        lastTapRef.current = 0;
        likeCurrent();
      } else {
        lastTapRef.current = now;
        singleTapTimerRef.current = window.setTimeout(() => {
          togglePlayPause();
          singleTapTimerRef.current = null;
        }, DOUBLE_TAP_MS);
      }
    } else {
      resetToRest();
    }
  };

  useEffect(() => {
    const handleWheel = (e: WheelEvent) => {
      e.preventDefault();
      
      const now = Date.now();
      const timeSinceLastWheel = now - ((handleWheel as any).lastWheelTime || 0);
      if (timeSinceLastWheel < 500) return;
      (handleWheel as any).lastWheelTime = now;

      if (e.deltaY > 0) {
        stepNext();
      } else if (e.deltaY < 0) {
        stepPrev();
      }
    };

    document.addEventListener('wheel', handleWheel, { passive: false });
    return () => document.removeEventListener('wheel', handleWheel);
  }, []);
  
  const handleLike = () => {
    const currentVideo = videoList[index];
    if (!currentVideo) return;
    http.put({ url: `/videos/${currentVideo.id}/like?userId=${userId}` }).then(res => {
      setLiked(prev => { const arr = prev.slice(); arr[index] = res.data.liked; return arr; });
      setLikes(prev => { const arr = prev.slice(); arr[index] = res.data.likes; return arr; });
    }).catch(() => {
      setLiked(prev => { const arr = prev.slice(); arr[index] = !arr[index]; return arr; });
      setLikes(prev => { const arr = prev.slice(); arr[index] = arr[index] + (liked[index] ? -1 : 1); return arr; });
    });
    setShowBigHeart(true);
    setTimeout(() => setShowBigHeart(false), 500);
  };

  const handleProgressPointer = (clientX: number) => {
    const v = videoRef.current;
    const wrap = progressWrapRef.current;
    if (!v || !wrap || !Number.isFinite(v.duration) || v.duration <= 0) return;
    const rect = wrap.getBoundingClientRect();
    const frac = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    v.currentTime = frac * v.duration;
    setProgress(frac);
  };

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = isMuted;
    const onVolumeChange = () => setIsMuted(v.muted);
    v.addEventListener("volumechange", onVolumeChange);
    return () => v.removeEventListener("volumechange", onVolumeChange);
  }, [isMuted, index]);

  const { isMobile, isTablet, isDesktop, isLargeDesktop } = screenSize;
  
  const buttonSize = isMobile ? 48 : isTablet ? 46 : 44;
  const iconSize = isMobile ? 24 : isTablet ? 22 : 20;
  const arrowSize = isMobile ? 36 : isTablet ? 34 : 32;
  
  const rightOffset = isMobile ? 20 : isTablet ? 16 : 14;
  const topOffset = isMobile ? 60 : isTablet ? 20 : 16;
  const bottomOffset = isMobile ? 160 : isTablet ? 150 : 142;

  const scaleRatio = Math.min(size.width / 400, 1.2);
  const avatarSize = Math.max(28, Math.min(38, 32 * scaleRatio));
  const stallNameFontSize = Math.max(12, Math.min(15, 13 * scaleRatio));
  const dotFontSize = Math.max(14, Math.min(18, 16 * scaleRatio));
  const buttonFontSize = Math.max(11, Math.min(13, 12 * scaleRatio));
  const buttonPadding = `${Math.max(4, Math.min(6, 5 * scaleRatio))}px ${Math.max(10, Math.min(16, 12 * scaleRatio))}px`;

  return (
    <div className="trending-videos-container" style={{ height: '100vh', overflow: 'hidden' }}>
      {isMobile ? (
        <div className="download-app-bar">
          <img src={logo} alt="App logo" className="app-logo" />
          <div className="app-details">
            <div className="app-title">Localites</div>
            <div className="app-desc">Open in the Localites app</div>
          </div>
          <a href="https://go-localites-in.app.link" className="open-btn" target="_blank" rel="noopener noreferrer">OPEN</a>
        </div>
      ) : (
        <div className="jumbotron">
          <div className="jumbotron-content">
            <span className="community-name">{code || 'Community'}</span>
          </div>
        </div>
      )}

      {!isMobile && (
        <div style={{ 
          position: "absolute", 
          right: rightOffset, 
          top: "50%", 
          zIndex: 19, 
          display: "flex", 
          flexDirection: "column", 
          alignItems: "center", 
          gap: isLargeDesktop ? 24 : 18, 
          transform: "translateY(-50%)", 
          pointerEvents: "auto" 
        }}>
          <button data-nodrag style={{ 
            width: buttonSize, 
            height: buttonSize, 
            display: "grid", 
            placeItems: "center", 
            background: "rgba(0,0,0,0.66)", 
            border: "none", 
            color: "#fff", 
            cursor: "pointer", 
            padding: 0, 
            borderRadius: "50%", 
            boxShadow: "0 2px 8px rgba(0,0,0,0.22)" 
          }} onClick={stepPrev} aria-label="Previous video" disabled={videoList.length <= 1}>
            <IconArrowUp size={arrowSize} />
          </button>
          <button data-nodrag style={{ 
            width: buttonSize, 
            height: buttonSize, 
            display: "grid", 
            placeItems: "center", 
            background: "rgba(0,0,0,0.66)", 
            border: "none", 
            color: "#fff", 
            cursor: "pointer", 
            padding: 0, 
            borderRadius: "50%", 
            boxShadow: "0 2px 8px rgba(0,0,0,0.22)" 
          }} onClick={stepNext} aria-label="Next video" disabled={videoList.length <= 1}>
            <IconArrowDown size={arrowSize} />
          </button>
        </div>
      )}

      <div className="video-shell" style={{
        width: "100%",
        background: "#111",
        marginTop: isMobile ? 0 : isTablet ? 20 : 30,
        minHeight: isMobile ? "calc(100vh - 52px)" : isTablet ? 700 : 600,
        padding: isMobile ? 0 : isTablet ? "10px 0" : "20px 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflow: "hidden"
      }}>
        {!isMobile && (
          <div style={{ 
            position: "absolute", 
            top: topOffset, 
            left: topOffset, 
            zIndex: 30, 
            background: "rgba(0,0,0,0.54)", 
            borderRadius: "999px", 
            boxShadow: "0 2px 8px rgba(0,0,0,0.24)", 
            display: "flex", 
            alignItems: "center", 
            padding: isTablet ? "8px 16px" : "6px 12px", 
            cursor: "pointer" 
          }} onClick={() => history.push(`/${code}`)}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            <span style={{ 
              color: "#fff", 
              fontSize: isTablet ? 16 : 15, 
              fontWeight: 500, 
              marginLeft: 4 
            }}>Dashboard</span>
          </div>
        )}

        <div ref={cardRef} style={{ 
          position: "relative", 
          width: size.width, 
          height: size.height, 
          background: "#000", 
          borderRadius: isMobile ? 0 : isTablet ? 8 : 12, 
          overflow: "hidden", 
          boxShadow: isMobile ? "none" : isTablet ? "0 2px 6px rgba(0,0,0,0.3)" : "0 1px 3px rgba(0,0,0,0.4)", 
          touchAction: "none", 
          userSelect: "none" 
        }} 
        onPointerDown={onPointerDown} 
        onPointerMove={onPointerMove} 
        onPointerUp={onPointerUp} 
        onPointerCancel={onPointerCancel} 
        onTouchStart={onTouchStart} 
        onTouchMove={onTouchMove} 
        onTouchEnd={onTouchEnd} 
        onContextMenu={e => e.preventDefault()}
        >
          
          <div style={{ position: "absolute", right: 10, top: 10, zIndex: 20, display: "flex", alignItems: "center", gap: 8 }}>
            <button data-nodrag style={{ 
              width: buttonSize, 
              height: buttonSize, 
              display: "grid", 
              placeItems: "center", 
              background: "none", 
              border: "none", 
              color: "#fff", 
              cursor: "pointer", 
              padding: 0, 
              borderRadius: "50%"
            }} onClick={() => setIsMuted(m => !m)} title={isMuted ? "Unmute" : "Mute"} aria-label={isMuted ? "Unmute" : "Mute"}>
              {isMuted ? <IconSpeakerOff size={iconSize} /> : <IconSpeakerOn size={iconSize} />}
            </button>
            
            <button data-nodrag style={{ 
              width: buttonSize, 
              height: buttonSize, 
              display: "grid", 
              placeItems: "center", 
              background: "none", 
              border: "none", 
              color: "#fff", 
              cursor: "pointer", 
              padding: 0, 
              borderRadius: "50%"
            }} onClick={() => setShowMenu((s) => !s)} title="Quality" aria-label="Quality">
              <IconGear size={iconSize} />
            </button>
            
            {/* ✅ UPDATED QUALITY MENU - Removed "Auto" option */}
            {showMenu && (
              <div data-nodrag style={{ 
                position: "absolute", 
                right: 10, 
                top: buttonSize + 5, 
                minWidth: isLargeDesktop ? 180 : 150, 
                borderRadius: 10, 
                overflow: "hidden", 
                background: "rgba(20,20,20,0.96)", 
                border: "1px solid rgba(255,255,255,0.12)", 
                color: "#fff", 
                fontSize: isLargeDesktop ? 15 : 14, 
                zIndex: 21 
              }} onMouseLeave={() => setShowMenu(false)}>
                {/* ✅ 1080p Option */}
                <div data-nodrag style={{ 
                  padding: isLargeDesktop ? "12px 14px" : "10px 12px", 
                  cursor: isNativeHls ? "not-allowed" : "pointer", 
                  background: quality === "1080p" ? "rgba(255,255,255,0.12)" : "transparent", 
                  opacity: isNativeHls ? 0.55 : 1, 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "space-between" 
                }} onClick={() => { 
                  if (!isNativeHls) { 
                    setQuality("1080p"); 
                    setShowMenu(false); 
                  } 
                }}>
                  <span>1080p</span>
                  {quality === "1080p" ? <span>✓</span> : <span />}
                </div>
                
                {/* ✅ 480p Option */}
                <div data-nodrag style={{ 
                  padding: isLargeDesktop ? "12px 14px" : "10px 12px", 
                  cursor: isNativeHls ? "not-allowed" : "pointer", 
                  background: quality === "480p" ? "rgba(255,255,255,0.12)" : "transparent", 
                  opacity: isNativeHls ? 0.55 : 1, 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "space-between" 
                }} onClick={() => { 
                  if (!isNativeHls) { 
                    setQuality("480p"); 
                    setShowMenu(false); 
                  } 
                }}>
                  <span>480p</span>
                  {quality === "480p" ? <span>✓</span> : <span />}
                </div>
                
                {/* Safari Warning */}
                {isNativeHls ? (
                  <div style={{ 
                    padding: isLargeDesktop ? "10px 14px" : "8px 12px", 
                    opacity: 0.6, 
                    fontSize: isLargeDesktop ? 13 : 12 
                  }}>
                    Safari controls quality automatically.
                  </div>
                ) : null}
              </div>
            )}
          </div>

          <video ref={videoRef} playsInline preload="metadata" crossOrigin="use-credentials" style={{ 
            width: "100%", 
            height: "100%", 
            objectFit: isMobile ? "cover" : "contain", 
            objectPosition: "center", 
            display: "block", 
            background: "#000" 
          }} loop muted={isMuted} />

          {/* Single line stall info - profile picture, full stall name, dot, smaller Shop Now button */}
          <div style={{ 
            position: "absolute", 
            left: 0, 
            bottom: 84, // Moved up to give space for title/description
            zIndex: 22, 
            width: isMobile ? "75%" : "72%", 
            paddingLeft: Math.max(14, Math.min(20, 16 * scaleRatio)), 
            pointerEvents: "none" 
          }}>
            {stallInfo && (
              <div style={{ 
                display: "flex", 
                alignItems: "center", 
                gap: Math.max(6, Math.min(10, 8 * scaleRatio)),
                padding: `${Math.max(4, Math.min(6, 5 * scaleRatio))}px 0`,
                pointerEvents: "auto",
                maxWidth: "100%"
              }}>
                {/* Profile Picture */}
                <img src={stallInfo.imageUrl || (stallInfo.imagePath ? general.getImageUrl(stallInfo.imagePath) : "/dummy.png")} alt={stallInfo.name || ""} style={{ 
                  width: avatarSize, 
                  height: avatarSize, 
                  borderRadius: "50%", 
                  objectFit: "cover", 
                  border: "2px solid #fff",
                  flexShrink: 0
                }} />
                
                {/* Full Stall Name - No ellipsis */}
                <span style={{ 
                  color: "#fff", 
                  fontWeight: 600, 
                  fontSize: stallNameFontSize, 
                  textShadow: "0 1px 3px rgba(0,0,0,0.8)",
                  whiteSpace: "nowrap",
                  flexShrink: 1,
                  minWidth: 0
                }}>{stallInfo.name || ""}</span>
                
                {/* Dot Separator */}
                <span style={{ 
                  color: "#fff", 
                  fontSize: dotFontSize, 
                  fontWeight: "bold",
                  textShadow: "0 1px 3px rgba(0,0,0,0.8)",
                  flexShrink: 0
                }}>•</span>
                
                {/* Smaller Shop Now Button */}
                <button data-nodrag style={{ 
                  background: "#ff7a00", 
                  color: "#fff", 
                  border: "none", 
                  borderRadius: Math.max(12, Math.min(16, 14 * scaleRatio)), 
                  padding: buttonPadding, 
                  fontWeight: 700, 
                  fontSize: buttonFontSize, 
                  cursor: "pointer", 
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  whiteSpace: "nowrap",
                  flexShrink: 0
                }} onClick={e => { 
                  e.stopPropagation(); 
                  if (stallInfo.slug) { 
                    history.push(`/${code}/stalls/${stallInfo.slug}`); 
                  } else if (stallInfo.id) { 
                    history.push(`/${code}/stalls/${stallInfo.id}`); 
                  } 
                }}>Shop Now</button>
              </div>
            )}
          </div>

          {/* Fixed position for title and description - no longer overlapping stall info */}
          <div style={{ 
            position: "absolute", 
            left: 0, 
            bottom: 36, 
            zIndex: 22, 
            width: isMobile ? "75%" : "72%", 
            paddingLeft: Math.max(14, Math.min(20, 16 * scaleRatio)), 
            pointerEvents: "none" 
          }}>
            {/* Title - Single line */}
            <div style={{ 
              color: "#fff", 
              fontWeight: 700, 
              fontSize: Math.max(13, Math.min(15, 14 * scaleRatio)), 
              textShadow: "0 2px 8px rgba(0,0,0,0.25)",
              marginBottom: Math.max(3, Math.min(6, 4 * scaleRatio)),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "95%"
            }}>{videoList[index]?.title || ""}</div>
            
            {/* Description - Single line, clickable for Instagram Reels drawer */}
            <div data-nodrag style={{ 
              color: "#e5e5e5", 
              fontWeight: 400, 
              fontSize: Math.max(13, Math.min(15, 14 * scaleRatio)), 
              textShadow: "0 1px 5px rgba(0,0,0,0.18)",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "95%",
              cursor: "pointer",
              pointerEvents: "auto"
            }} onClick={(e) => { 
              e.stopPropagation(); 
              setShowDescriptionDrawer(true); 
            }}>{videoList[index]?.description || ""}</div>
          </div>

          {/* Instagram Reels style description drawer with proper transparent background */}
          {showDescriptionDrawer && (
            <>
              {/* Transparent overlay background */}
              <div data-nodrag style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.6)", // Instagram-like transparent dark overlay
                zIndex: 50,
                pointerEvents: "auto",
                opacity: showDescriptionDrawer ? 1 : 0,
                transition: "opacity 0.3s ease"
              }} onClick={(e) => {
                e.stopPropagation();
                setShowDescriptionDrawer(false);
              }}>
                
                {/* Bottom drawer that slides up */}
                <div style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: "rgba(18, 18, 18, 0.95)", // Dark semi-transparent like Instagram
                  backdropFilter: "blur(20px)", // iOS-style blur effect
                  borderTopLeftRadius: 12,
                  borderTopRightRadius: 12,
                  padding: Math.max(20, Math.min(28, 24 * scaleRatio)),
                  maxHeight: "70%",
                  overflow: "auto",
                  transform: showDescriptionDrawer ? "translateY(0)" : "translateY(100%)",
                  transition: "transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)" // Instagram-like easing
                }} onClick={e => e.stopPropagation()}>
                  
                  {/* Instagram-style drag handle */}
                  <div style={{
                    width: 40,
                    height: 4,
                    background: "rgba(255, 255, 255, 0.4)",
                    borderRadius: 2,
                    margin: "-8px auto 24px auto"
                  }} />
                  
                  {/* Content with Instagram-style spacing */}
                  <div>
                    {/* Stall info at top of drawer */}
                    {stallInfo && (
                      <div style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: Math.max(16, Math.min(20, 18 * scaleRatio)),
                        gap: Math.max(10, Math.min(12, 11 * scaleRatio))
                      }}>
                        <img src={stallInfo.imageUrl || (stallInfo.imagePath ? general.getImageUrl(stallInfo.imagePath) : "/dummy.png")} alt={stallInfo.name || ""} style={{
                          width: Math.max(36, Math.min(44, 40 * scaleRatio)),
                          height: Math.max(36, Math.min(44, 40 * scaleRatio)),
                          borderRadius: "50%",
                          objectFit: "cover",
                          border: "2px solid rgba(255, 255, 255, 0.3)"
                        }} />
                        <span style={{
                          color: "#fff",
                          fontSize: Math.max(15, Math.min(17, 16 * scaleRatio)),
                          fontWeight: 600
                        }}>{stallInfo.name || ""}</span>
                      </div>
                    )}
                    
                    {/* Title */}
                    <h3 style={{
                      color: "#fff",
                      fontSize: Math.max(16, Math.min(18, 17 * scaleRatio)),
                      fontWeight: 700,
                      margin: `0 0 ${Math.max(12, Math.min(16, 14 * scaleRatio))}px 0`,
                      lineHeight: 1.3
                    }}>{videoList[index]?.title || ""}</h3>
                    
                    {/* Full description with Instagram-style formatting */}
                    <p style={{
                      color: "rgba(255, 255, 255, 0.85)",
                      fontSize: Math.max(14, Math.min(16, 15 * scaleRatio)),
                      fontWeight: 400,
                      lineHeight: 1.5,
                      margin: 0,
                      whiteSpace: "pre-line"
                    }}>{videoList[index]?.description || ""}</p>
                  </div>
                </div>
              </div>
            </>
          )}

          <div style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)", zIndex: 14, opacity: showBigHeart ? 1 : 0, transition: "opacity 250ms ease", pointerEvents: "none" }}>
            <IconHeart size={isLargeDesktop ? 110 : isMobile ? 100 : 96} color="#ff2d55" filled />
          </div>

          {/* Modified action buttons - heart with count and share */}
            <div style={{
              position: "absolute",
              right: 10,
              bottom: bottomOffset,
              display: "flex",
              flexDirection: "column",
              gap: isLargeDesktop ? 18 : 14,
              zIndex: 9,
              alignItems: "center"
            }}>
  {/* Like button + count */}
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, marginTop: -20 }}>


    <button data-nodrag style={{
  background: "none",
  border: "none",
  padding: 0,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "auto",
  height: "auto"
}} onClick={handleLike} title="Like" aria-label="Like">
  <IconHeart size={iconSize} color={liked[index] ? "#ff2d55" : "#fff"} filled={liked[index]} />
</button>

    {/* Likes count (safe access) */}
    <div aria-hidden="true" style={{
      color: "#fff",
      fontSize: isMobile ? 12 : isTablet ? 12 : 13,
      opacity: 0.95,
      textShadow: "0 1px 2px rgba(0,0,0,0.6)",
      pointerEvents: "none",
      minWidth: 28,
      textAlign: "center",
      fontWeight: 600
    }}>
      {typeof likes[index] === "number" ? likes[index] : 0}
    </div>
  </div>

  {/* Share button */}
  <button data-nodrag style={{
    width: buttonSize,
    height: buttonSize,
    display: "grid",
    placeItems: "center",
    background: "none",
    border: "none",
    color: "#fff",
    cursor: "pointer",
    padding: 0,
    borderRadius: "50%"
  }} onClick={() => {
    const currentVideo = videoList[index];
    if (!currentVideo) return;
    const url = `${window.location.origin}/${code}/trendingpage/${currentVideo.id}`;
    if (navigator.share) {
      navigator.share({ title: currentVideo.title, url }).catch(() => { });
    } else {
      navigator.clipboard.writeText(url).then(() => { alert("Link copied!"); });
    }
  }} title="Share" aria-label="Share">
    <IconShare size={iconSize - 2} />
  </button>
</div>


          {/* Modified play pause overlay */}
          {isPaused && (
            <div data-nodrag style={{ 
              position: "absolute", 
              left: "50%", 
              top: "50%", 
              transform: "translate(-50%, -50%)", 
              display: "flex", 
              flexDirection: "column", 
              alignItems: "center", 
              gap: isLargeDesktop ? 16 : 12, 
              zIndex: 15, 
              pointerEvents: "auto" 
            }}>
              <div onClick={() => { const v = videoRef.current; if (v) v.paused ? v.play() : v.pause(); }} style={{ cursor: "pointer" }} aria-label="Play/Pause">
                <IconPlay size={isLargeDesktop ? 80 : isMobile ? 72 : 64} />
              </div>
            </div>
          )}

          <div ref={progressWrapRef} data-nodrag style={{ 
            position: "absolute", 
            left: 0, 
            right: 0, 
            bottom: 0, 
            height: isLargeDesktop ? 4 : 3, 
            background: "rgba(255,255,255,0.18)", 
            zIndex: 18, 
            cursor: "pointer" 
          }} onPointerDown={(e) => { e.stopPropagation(); handleProgressPointer(e.clientX); }} onTouchStart={(e) => { e.stopPropagation(); if (e.touches?.[0]) handleProgressPointer(e.touches[0].clientX); }}>
            <div style={{ 
              height: "100%", 
              width: `${Math.max(0, Math.min(1, progress)) * 100}%`, 
              background: "#ff7a00", 
              transition: "width 120ms linear" 
            }} />
          </div>
        </div>
        {isLoadingMore && (
          <div style={{
            position: "absolute",
            bottom: 60,
            left: "50%",
            transform: "translateX(-50%)",
            background: "rgba(0, 0, 0, 0.7)",
            color: "#fff",
            padding: "8px 16px",
            borderRadius: 20,
            fontSize: 13,
            fontWeight: 500,
            zIndex: 25,
            pointerEvents: "none"
          }}>
            Loading more videos...
          </div>
        )}
      </div>
    </div>
  );
};

export default TrendingVideos;